
import { Component, Mixins } from "vue-property-decorator";
import { DefaultBrowserBehavior } from "amazon-chime-sdk-js";
import { detect } from "detect-browser";

import UserDetailsMixin from "@/mixins/UserDetailsMixin.vue";
import { BrowserName, CapabilitiyStep } from "@/interfaces/devices/browser";

@Component
export default class BrowserAndCapabilitiesMixin extends Mixins<
  UserDetailsMixin
>(UserDetailsMixin) {
  browserBehavior = new DefaultBrowserBehavior();
  isBrowserSupportDialogDisplay = false;

  isCapabilityStepsDialogDisplay = false;
  browserName = "";
  capabilitySteps: CapabilitiyStep[] = [];

  get isBrowserSupported() {
    return this.browserBehavior.isSupported();
  }

  get isScreenShareUnsupported() {
    return this.browserBehavior.screenShareUnsupported();
  }

  async created() {
    this.detectBrowser();
    if (
      !this.isBrowserSupported ||
      (this.isSalesRep && this.isScreenShareUnsupported)
    ) {
      this.isBrowserSupportDialogDisplay = true;
    }
  }

  detectBrowser() {
    const browser = detect();
    if (browser) {
      this.browserName = browser.name;
    }
    this.updateCapabilitySteps();
  }

  get isBrowserChrome() {
    return this.browserName === BrowserName.CHROME;
  }

  get isBrowserFirefox() {
    return this.browserName === BrowserName.FIREFOX;
  }

  get isBrowserSafari() {
    return this.browserName === BrowserName.SAFARI;
  }

  updateCapabilitySteps() {
    if (this.isBrowserChrome) {
      this.capabilitySteps = [
        {
          description: "Click on the <b>camera</b> icon.",
          image: require("../assets/capabilities/chrome/step1.png")
        },
        {
          description:
            "Change to <b>always allow</b>. Click <b>Done</b> and refresh the page.",
          image: require("../assets/capabilities/chrome/step2.png")
        }
      ];
    } else if (this.isBrowserFirefox) {
      this.capabilitySteps = [
        {
          description: "Click on the <b>camera</b> and <b>mic</b> icon.",
          image: require("../assets/capabilities/firefox/step1.png")
        },
        {
          description:
            "Click on the <b>X</b> next to <b>Blocked Temporarily</b> for both <b>Microphone</b> and <b>Camera</b>. Refresh the page.",
          image: require("../assets/capabilities/firefox/step2.png")
        },
        {
          description: "Select <b>Allow<b>.",
          image: require("../assets/capabilities/firefox/step3.png")
        }
      ];
    } else if (this.isBrowserSafari) {
      this.capabilitySteps = [
        {
          description:
            'Right click on the URL bar and choose <b>"Settings For This Website..."</b>',
          image: require("../assets/capabilities/safari/step1.png")
        },
        {
          description:
            'Change options for camera and microphone to <b>"Allow"</b>',
          image: require("../assets/capabilities/safari/step2.png")
        }
      ];
    }
  }
}
